// Empty base → requests use `/api/...` and CRA proxy forwards to http://localhost:5001
const envBase = process.env.REACT_APP_API_URL;

const BASE_URL =
  envBase !== undefined && envBase !== ""
    ? envBase
    : "";

export default BASE_URL;
